<template>
  <div class="lg:w-[55%]">
    <b-form-group
      id="input-group-1"
      label="Nama Toko/Brand*"
      label-for="input-1"
    >
      <b-form-input
        id="input-1"
        :value="formData.brand"
        type="text"
        placeholder="e.g Klinik Beauty Plus, L’oreal,"
        required
        maxlength="40"
        @input="$emit('update:brand', $event)"
      />
      <div class="text-right text-sm">
        <span>{{ formData.brand.length }}/40 Karakter</span>
      </div>
    </b-form-group>

    <b-form-group
      id="input-group-2"
      label="Nama Customer Service AI*"
      label-for="input-2"
    >
      <b-form-input
        id="input-2"
        :value="formData.name"
        type="text"
        placeholder="e.g Clara, Kiko, Tony, etc"
        required
        size="sm"
        maxlength="20"
        @input="$emit('update:name', $event)"
      />
      <div class="text-right text-sm">
        <span>{{ formData.name.length }}/20 Karakter</span>
      </div>
    </b-form-group>
    <!-- <b-form-group
      id="input-group-3"
      label="Gender*"
      label-for="input-3"
    >
      <b-form-input
        id="input-3"
        :value="formData.gender"
        type="text"
        placeholder="e.g Perempuan / Laki-laki"
        required
        @input="$emit('update:gender', $event)"
      />
    </b-form-group> -->
    <b-form-group
      label="Gender*"
    >
      <b-form-radio-group
        id="radio-group-1"
        v-model="formData.gender"
        :options="genderOptions"
        name="gender"
        required
        @input="$emit('update:gender', $event)"
      />
    </b-form-group>
    <b-form-group
      id="input-group-4"
      label="Gaya Bahasa*"
      label-for="input-4"
    >
      <b-form-input
        id="input-4"
        :value="formData.language_style"
        type="text"
        placeholder="e.g Formal, Friendly"
        required
        maxlength="20"
        @input="$emit('update:language_style', $event)"
      />
      <div class="text-right text-sm">
        <span>{{ formData.language_style.length }}/20 Karakter</span>
      </div>
    </b-form-group>
    <b-form-group
      id="input-group-5"
      label="Sapaan*"
      label-for="input-5"
    >
      <b-form-input
        id="input-5"
        :value="formData.greeting"
        type="text"
        placeholder="e.g Kak, Can, Bro etc"
        required
        maxlength="10"
        @input="$emit('update:greeting', $event)"
      />
      <div class="text-right text-sm">
        <span>{{ formData.greeting.length }}/10 Karakter</span>
      </div>
    </b-form-group>
    <b-form-group
      id="input-group-5"
      label="Job Description*"
      label-for="textarea-small"
    >
      <template #label>
        <div class="flex justify-between items-center">
          <div>
            Job Description*
          </div>
          <div class="flex gap-2">
            <b-button
              id="popover-target-1"
              variant="outline"
              size="sm"
              class="!w-fit !p-1 !border-[#E2E2E2]"
              @click="onResetJobDesc"
            >
              <b-img
                width="13"
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/refresh-2.svg"
              />
            </b-button>
            <b-popover
              target="popover-target-1"
              triggers="hover"
              placement="top"
              custom-class="custom-popover"
            >
              <div>
                Reset
              </div>
            </b-popover>
            <b-button
              :variant="isOnEdit?'primary':'outline'"
              size="sm"
              class="!p-1 !border-[#E2E2E2]"
              @click="onEditJobDesc"
            >
              {{ isOnEdit? 'Simpan': 'Edit' }}
            </b-button>
          </div>
        </div>
      </template>
      <b-form-textarea
        id="textarea-small"
        :value="formData.job_description"
        :disabled="!isOnEdit"
        class="min-h-[108px] resize-y"
        maxlength="2500"
        placeholder="Masukkan job description Customer Service kamu"
        @input="$emit('update:job_description', $event)"
      />
      <div class="text-right text-sm">
        <span>{{ formData.job_description.length }}/2500 Karakter</span>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { jobdescDefault } from './config'

export default {
  name: 'StepOne',
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
    disableNext: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOnEdit: false,
      defaultJobDesc: jobdescDefault,
      genderOptions: [
        { text: 'Laki-laki', value: 'male' },
        { text: 'Perempuan', value: 'female' },
      ],
    }
  },
  watch: {
    formData: {
      handler() {
        this.validateForm()
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    // Check form validity on component creation
    this.validateForm()
  },
  methods: {
    onEditJobDesc() {
      this.isOnEdit = !this.isOnEdit
      if (!this.isOnEdit) {
        this.validateForm()
      }
    },
    onResetJobDesc() {
      this.$emit('update:job_description', this.defaultJobDesc)
    },
    validateForm() {
      // Check if all required fields (excluding job_description) are filled
      const requiredFields = [
        'brand',
        'name',
        'gender',
        'language_style',
        'greeting',
        'job_description',
      ]

      const isFormValid = requiredFields.every(field => {
        const value = this.formData[field]
        // Pastikan value ada dan bukan string kosong setelah di-trim
        return value !== undefined && value !== null && String(value).trim() !== ''
      })
      // Emit the 'update:disableNext' event with the form validity
      this.$emit('update:disableNext', !isFormValid)
    },
  },
}
</script>
